import {trimValue} from './utilities';

let initialized = false;

export default class FpsDisplay {
    static init(styles = null) {
        // Stop if we've already initialized
        if (initialized) {
            return;
        }

        initialized = true;

        // Set default styles if none were provided
        styles = styles || {
            position: 'fixed',
            top: '8px',
            right: '8px',
            padding: '4px 8px',
            fontFamily: 'monospace',
            fontSize: '12px',
            lineHeight: '12px',
            color: 'red',
            backgroundColor: 'rgba(255, 255, 255, 1)',
            borderRadius: '4px',
            boxShadow: 'rgba(0, 0, 0, 0.25) 0px 2px 16px',
            pointerEvents: 'none',
            zIndex: '9999',
        };

        // Create our DOM element
        const container = document.createElement('div');
        Object.assign(container.style, styles);
        document.body.appendChild(container);

        // Create loop
        let fps = 0;
        let lastTickTime = (new Date()).getTime();
        const tick = () => {
            // Calculate our averaged frame time
            const thisTickTime = (new Date()).getTime();
            fps =
                (fps * 0.9) +
                ((thisTickTime - lastTickTime) * 0.1);

            lastTickTime = thisTickTime;

            // Update display
            if (fps != 0) {
                container.innerText = `${trimValue(1000 / fps, 1)} fps`;
            }

            // Schedule next tick
            window.requestAnimationFrame(tick);
        };

        // Start
        tick();
    }
}
